import { render, staticRenderFns } from "./CodeObtain.vue?vue&type=template&id=0d3b8fde&scoped=true"
import script from "./CodeObtain.vue?vue&type=script&lang=js"
export * from "./CodeObtain.vue?vue&type=script&lang=js"
import style0 from "./CodeObtain.vue?vue&type=style&index=0&id=0d3b8fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b8fde",
  null
  
)

export default component.exports